import { Route, Routes } from 'react-router-dom';
import LandingPage from '@/pages/LandingPage';
import SignupPage from '@/pages/SignupPage';
import LoginPage from '@/pages/LoginPage';
import ForgotPasswordPage from '@/pages/ForgotPasswordPage';
import ResetPasswordPage from '@/pages/ResetPasswordPage';
import EmailConfirmationPage from '@/pages/EmailConfirmationPage';
import GamePage from '@/pages/GamePage';
import TrainingPage from '@/pages/TrainingPage';
import CrimesPage from '@/pages/CrimesPage';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { StateBadge } from '@/components/StateBadge';
import { useAuthStore } from '@/stores/auth';

export default function App(): JSX.Element {
  const authStatus = useAuthStore((s) => s.status);

  return (
    <>
      {authStatus === 'authenticated' && <StateBadge />}
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/confirm-email" element={<EmailConfirmationPage />} />
        <Route
          path="/game"
          element={
            <ProtectedRoute>
              <GamePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/training"
          element={
            <ProtectedRoute>
              <TrainingPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/crimes"
          element={
            <ProtectedRoute>
              <CrimesPage />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<LandingPage />} />
      </Routes>
    </>
  );
}
